(function () {
  const SELECTORS = [
    '.header__submenu',        // dropdowns estándar
    '.mega-menu__list',        // listas dentro de mega-menu
    '.list-menu--disclosure'   // submenús en <details>
  ];

  const ITEM_THRESHOLD = 10; // cambia a 8/6 si quieres activar antes
  const isDesktop = () => window.matchMedia('(min-width: 992px)').matches;

  function toggleTwoCols() {
    SELECTORS.forEach(sel => {
      document.querySelectorAll(sel).forEach(ul => {
        // Evita tocar rejillas especiales del mega-menu si el tema las marca como grid
        if (ul.closest('.mega-menu') && ul.classList.contains('grid')) return;

        const items = ul.querySelectorAll(':scope > li').length;
        if (isDesktop() && items >= ITEM_THRESHOLD) {
          ul.setAttribute('data-two-cols', '');
        } else {
          ul.removeAttribute('data-two-cols');
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', toggleTwoCols);
  window.addEventListener('resize', toggleTwoCols);

  // Reevalúa cuando abren/cambian <details> de menús
  document.addEventListener('toggle', (e) => {
    if (e.target instanceof HTMLDetailsElement) {
      setTimeout(toggleTwoCols, 60);
    }
  });

  // Por si el tema manipula menús por click/hover
  document.addEventListener('click', () => {
    clearTimeout(window.__twoColsTO);
    window.__twoColsTO = setTimeout(toggleTwoCols, 120);
  });
})();
